const TextInput = ({
  label,
  name,
  value = "",
  onChange,
  required = false,
  error = "",
  helperText = "",
  ...props
}) => {
  return (
    <label className="app-form-field">
      <span className="app-form-label">
        {label}

        {required && (
          <span aria-hidden="true">
            {" "}*
          </span>
        )}
      </span>

      <input
        type="text"
        name={name}
        value={value}
        required={
          required
        }
        onChange={
          onChange
        }
        {...props}
      />

      {helperText &&
        !error && (
          <small className="app-form-helper">
            {helperText}
          </small>
        )}

      {error && (
        <small className="app-form-error">
          {error}
        </small>
      )}
    </label>
  );
};

export default TextInput;